import { render, staticRenderFns } from "./btn-arrow-secondary.vue?vue&type=template&id=5e5a159d&scoped=true&"
import script from "./btn-arrow-secondary.vue?vue&type=script&lang=js&"
export * from "./btn-arrow-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5a159d",
  null
  
)

export default component.exports